export const LIST_EXISTS = 'LIST_EXISTS';
export const LIST_IMPORT = 'LIST_IMPORT';
export const LIST_NOT_VALID_FOR_STRUCTURE = 'LIST_NOT_VALID_FOR_STRUCTURE';

export const STEP_START = 'STEP_START';
export const STEP_PREVIEW = 'STEP_PREVIEW';
export const MISSING_ITEM = 'Missing Item';
